import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncTurnReportEdit = lazy(() => import('~/containers/TurnReportEdit'));

export default [
  <Route path="/turn-reports/:turnReportId">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncTurnReportEdit />
    </Suspense>
  </Route>,
];
